import { Component } from 'react';
import clsx from 'clsx';

import { Typography } from 'omakase';

interface Props {
  heading: string;
  modifierClassName?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subheading?: any;
  hide?: boolean;
}

class SectionHeader extends Component<Props> {
  render() {
    const { heading, hide, modifierClassName, subheading, ...rest } = this.props;

    if (hide) {
      return null;
    }
    const className = clsx('ConsumerSection-header', modifierClassName);

    return (
      <header className={className} {...rest}>
        <Typography
          component="h1"
          variant="heading02"
          className="ConsumerSection-heading"
          data-testid="consumer-header"
        >
          {heading}
        </Typography>

        {subheading && (
          <div className="ConsumerSection-subheading">
            <Typography component="span" variant="body02">
              {subheading}
            </Typography>
          </div>
        )}
      </header>
    );
  }
}

export default SectionHeader;
